import React from "react";
import { Modal, Section } from "@allxsmith/bestax-bulma";
import Spinner from "react-spinner-material";
import LoadingSpinner from "./Spinner";



export default function LoadingModal({open, setOpen}){

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
      <Modal
      closeOnBlur
      active={open}
      onClose={() => {
          setOpen(false);
      }}
    >
        <Modal.Content>
          <Section style={{backgroundColor: "white"}}>
            <LoadingSpinner/>
          </Section>
        </Modal.Content>
      </Modal>
    );




}